import { fromNearestStoresQueryToNearestStores } from "../../../../hooks/api/adapters/hooks/api/adapters/fromNearestStoresQueryToNearestStores.js";
import { GET_STORE_DETAILS } from "../../../../operations/queries/operations/queries/get-store-details.js";
import { fromStoreQueryDataToStoreDetails } from "../../../../hooks/api/adapters/hooks/api/adapters/fromStoreQueryDataToStoreDetails.js";
import { GET_NEAREST_STORES } from "../../../../operations/queries/operations/queries/get-nearest-stores.js";
async function getPageData(apolloClient, slug, locale, withNearestStores = false, maxDistance) {
  try {
    const storeQuery = await apolloClient.query({
      query: GET_STORE_DETAILS,
      variables: {
        slug
      },
      ...locale ? {
        context: {
          forwardHeaders: {
            "Accept-Language": locale
          }
        }
      } : {}
    });
    const storeQueryData = storeQuery.data?.store;
    const storeData = fromStoreQueryDataToStoreDetails(storeQueryData);
    if (storeQuery.error) {
      console.error(storeQuery.error);
    }
    const nearestStores = [];
    if (withNearestStores && storeData?.lat !== void 0 && storeData?.lon !== void 0) {
      const nearestStoresQuery = await apolloClient.query({
        query: GET_NEAREST_STORES,
        variables: {
          searchGeoLocation: { lat: storeData?.lat, lon: storeData?.lon },
          forceDistance: true,
          maxResults: 2,
          maxDistance,
          filter: {
            excludeGlobalStoreId: `${storeData?.globalStoreId}`
          }
        }
      });
      const nearestStoresQueryData = nearestStoresQuery.data?.storesByDistance;
      nearestStores.push(...fromNearestStoresQueryToNearestStores(nearestStoresQueryData) ?? []);
      if (nearestStoresQuery.error) {
        console.error(nearestStoresQuery.error);
      }
    }
    return { storeData, nearestStores };
  } catch (e) {
    console.error(e);
    return { storeData: null, nearestStores: [] };
  }
}
export {
  getPageData
};
//# sourceMappingURL=data.js.map
